import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/collapse/index.js
// module id = 633
// module chunks = 1